/**
 * Convert a human-readable course duration ("1h 30m", "49m", "9 min",
 * "10+ hours", "4 weeks") to an ISO 8601 duration for JSON-LD
 * (schema.org timeRequired expects e.g. "PT1H30M", "P4W").
 * Returns undefined for values with no clean ISO equivalent
 * (e.g. "1 hour per week", empty strings) so callers can omit the field.
 */
export function toIsoDuration(human: string | undefined): string | undefined {
  if (!human) return undefined
  const s = human.trim().toLowerCase()
  if (!s || s.includes('per ')) return undefined

  const weeks = s.match(/(\d+)\s*(?:weeks?|w)\b/)
  if (weeks) return `P${weeks[1]}W`

  const hours = s.match(/(\d+)\s*\+?\s*(?:hours?|hrs?|h)(?![a-z])/)
  const minutes = s.match(/(\d+)\s*(?:minutes?|mins?|m)(?![a-z])/)
  if (!hours && !minutes) return undefined

  let out = 'PT'
  if (hours) out += `${hours[1]}H`
  if (minutes) out += `${minutes[1]}M`
  return out
}
